<template>
  <div>
    <div class="sign-in__fields">
      <template v-if="!isSignedIn">
        <cdr-text
          tag="span"
          class="sign-in__subheading"
        >
          This is the account you use to shop REI.com, see
          purchase history and rewards, and manage your information.
        </cdr-text>
        <cdr-button
          v-if="mainSignInCta?.href"
          :href="mainSignInCta.href"
          data-ui="sign-in-button"
          tag="a"
          @click="handleSignInClick"
        >
          {{ mainSignInCta.text }}
        </cdr-button>
      </template>
      <template v-else>
        <cdr-button
          class="confirm-membership__submit-complete"
          tag="a"
          modifier="secondary"
          disabled
        >
          <icon-check-lg />
          Signed in
        </cdr-button>
      </template>
    </div>
    <div class="sign-in__footnote">
      <cdr-text tag="span">
        {{ footnote.prompt }}
      </cdr-text>
      <cdr-link
        :href="footnote.href"
        modifier="standalone"
        @click="handleCreateAccountClick"
      >
        {{ footnote.text }}
      </cdr-link>
    </div>
  </div>
</template>

<script>
import {
  CdrButton,
  CdrLink,
  CdrText,
  IconCheckLg,
} from '@rei/cedar';
import { metricsLink } from '#utils/analytics';

export default {
  name: 'SignIn',
  components: {
    CdrButton,
    CdrLink,
    CdrText,
    IconCheckLg,
  },
  props: {
    isSignedIn: {
      type: Boolean,
      required: true,
    },
    isPreApproval: {
      type: Boolean,
      required: true,
    },
    isEmployee: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    footnote() {
      const signOutCta = {
        href: '/youraccount/logout?toUrl=/membership/mastercard/instant-credit',
        text: 'Sign out of this account',
        prompt: 'Not you?',
      };
      const createAccountCta = {
        href: '/yaRegistration?toUrl=/membership/mastercard/instant-credit',
        text: 'Create one now',
        prompt: 'Don’t have an online account?',
      };
      return this.isSignedIn ? signOutCta : createAccountCta;
    },
    mainSignInCta() {
      const preApprovalSignInCta = {
        href: '/login?toUrl=/membership/mastercard/preapproval',
        text: 'Sign in',
      };
      const signInCta = {
        href: `/login?toUrl=/membership/mastercard/instant-credit${this.isEmployee ? '-employee' : ''}`,
        text: 'Sign in',
      };

      return this.isPreApproval ? preApprovalSignInCta : signInCta;
    },
  },
  methods: {
    /* c8 ignore start */
    handleSignInClick() {
      metricsLink('applet_Sign In');
    },
    handleCreateAccountClick() {
      const text = this.isSignedIn ? 'Sign out' : 'Create account';
      metricsLink(`applet_${text}`);
    },
    /* c8 ignore end */
  },
};
</script>

<style lang="scss">

.sign-in__subheading {
  display: block;
  @include cdr-text-utility-sans-200;
  margin-bottom: $cdr-space-one-x;
}

.sign-in__footnote {
  display: flex;
  justify-content: space-between;
  padding-top: $cdr-space-one-x;
  margin-top: $cdr-space-one-x;
  position: relative;
  & > * {
    @include cdr-text-heading-sans-200;
  }

  &::before {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    left: 0;
    margin: auto;
    transform: scaleX(1.5);
    border-top: 1px solid $cdr-color-border-primary;
  }
}

.confirm-membership__submit-complete {
  @include cdr-button-secondary-mixin;
  column-gap: $cdr-space-half-x;
  color: $cdr-color-text-brand;
  box-shadow: inset 0 0 0 1px $cdr-color-text-brand;
  fill:  $cdr-color-text-brand;

  svg {
    height: 20px!important;
    width: 20px!important;
  }
}

.confirm-membership__submit-complete[disabled] {
  @include confirmed-disabled-button;
}

.sign-in--complete {
  .sign-in__icon {
    fill: $cdr-color-text-success;
  }
  .sign-in__heading {
    color: $cdr-color-text-success;
  }
}
</style>
